import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import AppointmentRow from './AppointmentRow';

// Walk-ins & queue: people currently on the floor (arrived) plus a CTA to book a walk-in.
const WaitingQueue = ({ waiting, currency, onStatusChange }) => (
  <div className="space-y-4">
    <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h2 className="font-display text-2xl font-light text-ink-900">Walk-ins &amp; queue</h2>
        <p className="mt-1 text-sm text-ink-700/80">
          Guests who have arrived and are waiting or being served.
        </p>
      </div>
      <Link
        to="/app/calendar"
        className="inline-flex flex-none items-center justify-center gap-2 bg-saffron-500 px-4 py-3 text-sm font-semibold uppercase tracking-[0.12em] text-ink-900 transition-colors hover:bg-saffron-400"
      >
        <Plus className="h-4 w-4" />
        Book walk-in
      </Link>
    </div>

    {waiting.length === 0 ? (
      <div className="bg-sand-50 px-5 py-12 text-center ring-1 ring-ink-900/10">
        <p className="font-display text-2xl font-light text-ink-900">Queue is clear</p>
        <p className="mt-2 text-sm text-ink-700/70">
          Mark a booking as arrived and they&rsquo;ll land here.
        </p>
      </div>
    ) : (
      <div className="bg-sand-50 ring-1 ring-ink-900/10">
        <ul className="divide-y divide-ink-900/10">
          {waiting.map((appt) => (
            <AppointmentRow
              key={appt.id}
              appointment={appt}
              currency={currency}
              onStatusChange={onStatusChange}
              actions={[{ status: 'completed', label: 'Checkout', primary: true }]}
            />
          ))}
        </ul>
      </div>
    )}
  </div>
);

export default WaitingQueue;
